<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">{{ $t("poinward") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("poinward") }} {{ $tc("incinematic") }}
        </div>
      </div>

      <div>
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp;
            <strong>{{ rows }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row mb-3">
        <div class="col-3">
          <b-form-input
            v-debounce:300="getPurchaseOrderList"
            v-model="searchValue"
            type="search"
            placeholder="Search..."
          ></b-form-input>
        </div>

        <div class="col-lg-3 col-xl-3">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selectedCinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in cinemaList"
                :key="dropdownIndex"
                href="#"
                @click="onDropdownChange($event, dropdownItem)"
                >{{ dropdownItem.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="fromDate"
                v-on:click="fromDate = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="fromDate"
                ref="programaticOpen"
                :value="fromDate"
                typeable
                v-validate="'required'"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="toDate"
                v-on:click="toDate = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="toDate"
                ref="programaticOpen"
                :value="toDate"
                typeable
                v-validate="'required'"
                :disabledDates="{ to: fromDate }"
              ></Datepicker>
              <label :class="toDate ? 'active' : ''">{{ $t("todate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-2">
          <button @click="getPurchaseOrderList" class="btn-blue w-100">
            Fetch
          </button>
        </div>

        <div
          v-if="purchaseOrders && purchaseOrders.length > 0"
          class=" col-xl-12 d-flex justify-content-end align-items-center mt-3"
        >
          <div>{{ $t("download") }} as:</div>
          <!-- <a
          v-if="getDailyPDFFileName"
          :href="BASE_URL+getDailyPDFFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
      </a>-->
          <a
            v-if="excelFile"
            :href="BASE_URL + excelFile"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <!-- LIST VIEW -->
      <table class="list-view-table text-center" v-if="listView">
        <thead>
          <tr>
            <th class="text-left">{{ $t("po") }} {{ $t("date") }}</th>
            <th class="text-left">{{ $t("ponumber") }}</th>
            <th class="text-left">{{ $tc("vendor", 1) }}</th>
            <th class="text-left">{{ $tc("status", 1) }}</th>
          </tr>
        </thead>

        <tbody v-if="purchaseOrders.length > 0">
          <template v-for="(purchaseOrder, pindex) in purchaseOrders">
            <tr :key="purchaseOrder.po_number + String(pindex)">
              <td class="text-left">{{ purchaseOrder.po_date | dateparse }}</td>
              <td class="text-left">{{ purchaseOrder.po_number }}</td>
              <td class="text-left">{{ purchaseOrder.v_name }}</td>
              <td class="text-left">{{ getPOStatus(purchaseOrder) }}</td>
              <td class="d-flex justify-content-end">
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="purchaseOrder.stock_status != 'In'"
                    @click="goToRoute('/fnb/bulk-edit-stock-in', purchaseOrder)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("Bulk") }} {{ $t("create") }} {{ $t("GRN") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/fnb/view-grn', purchaseOrder)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $tc("view", 1) }} {{ $t("all") }} {{ $t("GRN") }}
                  </b-dropdown-item>
                  <!--
                <b-dropdown-item
                  @click="goToRoute('/fnb/add-good-return', purchaseOrder)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $tc("create", 1) }} {{ $t("goodreturn") }}
                </b-dropdown-item>
                -->
                </b-dropdown>

                <div
                  class="icon-eye blue-icon btn"
                  @click="showHideDetails(purchaseOrder)"
                ></div>
              </td>
            </tr>
            <tr
              :style="purchaseOrder.more ? '' : 'display: none'"
              :key="purchaseOrder.po_number"
            >
              <td colspan="100%">
                <b-collapse v-model="purchaseOrder.more">
                  <!-- LIST VIEW -->
                  <table
                    class="list-view-table text-center"
                    style="width: 100%;"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t("ponumber") }}</th>
                        <th>{{ $t("po") }} {{ $t("date") }}</th>
                        <th>{{ $t("po") }} {{ $t("quantity") }}</th>
                        <th>{{ $tc("rawmaterials", 2) }}</th>
                        <th>{{ $tc("vendor", 1) }}</th>
                        <th>
                          {{ $t("store") }} {{ $t("in") }} {{ $t("quantity") }}
                        </th>
                        <th>{{ $t("uom") }}</th>
                        <!-- <th>{{ $tc('transferred', 2) }} {{ $t('stock') }} {{ $t('quantity') }}</th> -->
                        <th class="text-right">
                          <div class="pr-4">{{ $tc("status", 1) }}</div>
                        </th>
                      </tr>
                    </thead>

                    <tbody
                      v-if="
                        purchaseOrder.AllStockInFromPONumber &&
                          purchaseOrder.AllStockInFromPONumber.length > 0
                      "
                    >
                      <tr
                        v-for="(purchaseOrderDetail,
                        purchaseOrderList) in purchaseOrder.AllStockInFromPONumber"
                        :key="purchaseOrderList"
                      >
                        <td>{{ purchaseOrderDetail.po_number }}</td>
                        <td>{{ purchaseOrderDetail.po_date | dateparse }}</td>
                        <td>{{ purchaseOrderDetail.poi_qty }}</td>
                        <td>{{ purchaseOrderDetail.rm_name }}</td>
                        <td>{{ purchaseOrderDetail.v_name }}</td>
                        <td>{{ purchaseOrderDetail.sum_stock_in_quantity }}</td>
                        <td>{{ purchaseOrderDetail.uom_unit }}</td>
                        <!-- <td>{{ purchaseOrder.sum_stock_in_quantity }}</td> -->
                        <td class="d-flex justify-content-end">
                          {{ purchaseOrderDetail.stock_status }}
                          <b-dropdown right variant="edit" class="ml-4">
                            <b-dropdown-item
                              v-if="purchaseOrderDetail.stock_status != 'In'"
                              @click="
                                goToRoute(
                                  '/fnb/bulk-edit-stock-in',
                                  purchaseOrderDetail
                                )
                              "
                            >
                              <span class="edit-pen"></span>
                              {{ $t("create") }} {{ $t("GRN") }}
                            </b-dropdown-item>
                            <b-dropdown-item
                              @click="
                                goToRoute('/fnb/view-grn', purchaseOrderDetail)
                              "
                            >
                              <span class="icon-eye mr-1"></span>
                              {{ $tc("view", 1) }} {{ $t("GRN") }}
                            </b-dropdown-item>
                            <b-dropdown-item
                              @click="
                                goToRoute(
                                  '/fnb/add-good-return',
                                  purchaseOrderDetail
                                )
                              "
                            >
                              <span class="edit-pen mr-1"></span>
                              {{ $tc("create", 1) }} {{ $t("goodreturn") }}
                            </b-dropdown-item>
                          </b-dropdown>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">
                          <NoRecords />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(purchaseOrder, purchaseOrderkey) in purchaseOrders"
        :key="purchaseOrderkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ purchaseOrder.po_number }}</h6>
            <h6>{{ purchaseOrder.rm_name }}</h6>
            <h6>{{ purchaseOrder.v_name }}</h6>
            <h6>{{ purchaseOrder.stock_status }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/fnb/edit-stock-in', purchaseOrder)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-stock-in', purchaseOrder)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>-->
        </div>
      </div>
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        submitted: false,
        gridView: false,
        listView: true,
        purchaseOrders: [],
        stock_in_id: "",
        stock_in_details: {},
        UomList: [],
        Cinemas: [],
        selectedCinema: "",
        selectedUom: "",
        stock_quantity: "",
        stock_in_quantity: 0,

        storeManagementsLevels: [],
        selectedStoreLevel: "",
        sm_id: "",
        searchValue: "",
        searchKey: "po_number", //the key name in your table
        excelFile: null,
        fromDate: "",
        toDate: "",
        cinemaList: [],
        cinemaListCopy: [],
        searchCinema: "",
        obj: null,
        isRoleID: true,
      };
    },
    watch: {
      searchValue: function(newValue, oldValue) {
        if (String(newValue).length == 0) {
          this.searchValue = "";
          this.getPurchaseOrderList();
        }
      },
    },
    mounted() {
      this.obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      this.getPurchaseOrderList();
      this.getCinemas(this.obj);
      this.getUoM();
    },
    beforeMount() {
      this.getviewingnumber();
    },
    methods: {
      getPOStatus(purchaseOrder) {
        let status = "";

        let In = purchaseOrder.AllStockInFromPONumber.map(
          (x) => x.stock_status
        ).filter((x) => x === "In");
        let Pending = purchaseOrder.AllStockInFromPONumber.map(
          (x) => x.stock_status
        ).filter((x) => x === "Pending");

        if (In.length === purchaseOrder.AllStockInFromPONumber.length) {
          status = "Completed";
        } else if (
          Pending.length === purchaseOrder.AllStockInFromPONumber.length
        ) {
          status = "Pending";
        } else {
          status = "Partial Received";
        }

        return status;
      },
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.cinemaList = this.cinemaListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.cinemaList = this.cinemaListCopy;
        }
      },
      onDropdownChange: function(event, item) {
        this.selectedCinema = item.cine_name;
        this.obj = item.cine_id;
        this.searchCinema = "";
        this.onSearchCinema(null);
        this.getPurchaseOrderList();
      },
      onSearch(event) {
        this.searchValue = "";
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.searchValue = event;
          this.getPurchaseOrderList();
        }, 1500);
        // console.log('TO DO :>> ');
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getPurchaseOrderList();
        } else {
          this.currentPage = event;
          this.getPurchaseOrderList();
        }
      },
      getUoM: function() {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.UomList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getCinemas: function(cine_id) {
        let payload = null;
        cine_id == null
          ? (payload = { tableName: "ms_cinemas", cine_is_active: "Y" })
          : (payload = {
              tableName: "ms_cinemas",
              cine_is_active: "Y",
              cine_id: cine_id,
            });
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinemaList = data.Records;
              this.cinemaListCopy = data.Records;

              this.cinemaList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.onDropdownChange(null, {
                    cine_id: x.cine_id,
                    cine_name: x.cine_name,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      clearSelectedDate: function() {
        this.stock_in_details.stock_in_moved_to_stock_date = "";
      },
      clearSelectedDate1: function() {
        this.stock_in_details.stock_in_expiry_date = "";
      },
      onSelectUnitOfM: function(params) {
        console.log(params);
        this.stock_in_details["uom_id"] = params.uom_id;
        this.selectedUom = params.uom_unit;
      },
      onSelectCinema: function(params) {
        this.stock_in_details["cinema_id"] = params.cine_id;
        this.selectedCinema = params.cine_name;
        this.getStoreManagement(params.cine_id);
      },
      getStoreManagement(cinema_id) {
        this.storeManagementsLevels = [];
        this.selectedStoreLevel = "";
        let payload = {
          tableName: "store_management",
          sm_is_active: "Y",
          cinema_id: cinema_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.storeManagementsLevels = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectStore: function(store) {
        this.selectedStoreLevel = store.sm_store_name;
        this.sm_id = store.sm_id;
      },
      getStockInDetails: function(purchaseOrder) {
        this.stock_in_id = purchaseOrder.stock_in_id;
        let payload = {
          stock_in_id: purchaseOrder.stock_in_id,
          po_id: purchaseOrder.po_id,
          rm_id: purchaseOrder.rm_id,
        };
        PosFnbService.GetSumStockInDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.stock_in_details = data.Records[0];
              this.stock_in_details.stock_in_moved_to_stock_date === null
                ? (this.stock_in_details.stock_in_moved_to_stock_date = new Date())
                : this.stock_in_details.stock_in_moved_to_stock_date;
              this.GetUomForStockIn(this.stock_in_details);
              this.stock_in_quantity = this.stock_in_details
                .sum_stock_in_quantity
                ? parseInt(
                    this.stock_in_details.sum_stock_in_quantity -
                      parseInt(this.stock_in_details.stock_in_moved_quantity)
                  )
                : 0;
              this.$refs.updateStock.show();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      GetUomForStockIn: function(stock_in_details) {
        let payload = {
          rm_id: stock_in_details.rm_id,
          po_id: stock_in_details.po_id,
        };
        PosFnbService.GetUomForStockIn(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.stock_in_details["uom_id"] = data.Records[0].uom_id;
                this.selectedUom = data.Records[0].uom_unit;
                this.poi_qty = data.Records[0].poi_qty;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      showHideDetails: function(po) {
        if (po.hasOwnProperty("more")) {
          po.more = !po.more;
        } else po.more = true;

        this.purchaseOrders.forEach((p) => {
          if (po.po_id != p.po_id) {
            p.more = false;
          }
        });

        this.$forceUpdate();
      },
      goToRoute: function(path, purchaseOrder) {
        let {
          stock_in_id,
          po_id,
          rm_id,
          cinema_id,
          cine_id,
          AllStockInFromPONumber = [],
        } = purchaseOrder;
        console.log(purchaseOrder);

        let rm_ids = AllStockInFromPONumber.length
          ? AllStockInFromPONumber.map((x) => x.rm_id)
          : [rm_id];

        this.$router.push({
          path: path,
          query: {
            stock_in_id: stock_in_id,
            po_id: po_id,
            rm_id: rm_id,
            cinema_id: cine_id,
            rm_ids,
          },
        });
      },

      getPurchaseOrderList: function() {
        let loader = this.$loading.show();

        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchKey: this.searchKey,
          searchValue: this.searchValue,
          cine_id: this.obj,
          groupByPoIdOnly: true,
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
        PosFnbService.GetAllStockIn(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.purchaseOrders = data.Records;
              this.excelFile = data.FinalExcelFile;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.purchaseOrders = [];
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
              this.$toasted.show("No Records Found");
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally((x) => setTimeout(() => loader.hide(), 1000));
      },
      onClose: function() {
        this.$refs.updateStock.hide();
      },
      OnFinalSubmit: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            let payload = {
              ...this.stock_in_details,
              stock_in_id: this.stock_in_id,
              stock_quantity: this.stock_quantity,
              sm_id: this.sm_id,
            };
            PosFnbService.updatStockDetails(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$toasted.show(data.message);
                  this.$refs.updateStock.hide();
                  this.stock_in_quantity = 0;
                  this.stock_in_details = {};
                  this.stock_quantity = 0;
                  this.selectedCinema = "";
                  this.selectedUom = "";
                  this.selectedStoreLevel = "";
                  this.$nextTick(() => {
                    this.$validator.reset();
                    this.$forceUpdate();
                    this.getPurchaseOrderList();
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/stockIn.vue